
<ng-container *ngIf="appMenuType != -1">

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">
    
            <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>
    
            <span class="my-auto f16 fw-bold me-2"> 
    
                {{ 
                    bTravel ? 'سفر برون سازمانی' :
                
                    bStaffTravel ? 'سفر های پرسنل من' :
    
                    bManageTravel ? 'مدیریت سفرها ' :
                    
                    'اتوماسیون اداری'
                
                }}
                
                 
            </span>
    
        </div>
    
    </div>

</ng-container>

<main class="d-flex col-12 dirI bg-th-yellow" 

    [ngStyle]="{'min-height': appMenuType == -1 ? 'fit-content' : '',
    
                'padding': appMenuType == -1 ? '0px 2px 13px' : ''}">

    <!-- منوی اتوماسیون اداری -->

    <ng-container *ngIf="!bTravel && !bStaffTravel && !bManageTravel">

        <div class="d-flex flex-column bg-white rounded align-items-stretch flex-shrink-0 dirI col-md-2">

            <a class="d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom">

                <span class="fs-5 fw-semibold">نوع عملیات</span>

            </a>

            <div class="list-group list-group-flush border-bottom scrollarea">

                <a class="list-group-item list-group-item-action py-3 lh-tight pointer" (click)="setType(0)" id="0">

                    <div class="d-flex w-100 align-items-center justify-content-between">

                        <strong class="mb-1">ثبت سفر اداری</strong>

                    </div>

                    <div class="col-10 mb-1 small">توضیحات</div>

                </a>

                <a class="list-group-item list-group-item-action py-3 lh-tight pointer" (click)="setType(1)" id="1">

                    <div class="d-flex w-100 align-items-center justify-content-between">

                        <strong class="mb-1">ثبت سفر اداری درون سازمانی</strong>

                    </div>

                    <div class="col-10 mb-1 small">توضیحات</div>

                </a>

                <a class="list-group-item list-group-item-action py-3 lh-tight pointer" (click)="setType(2)" id="2">

                    <div class="d-flex w-100 align-items-center justify-content-between">

                        <strong class="mb-1">تعیین سرویس های پرسنل

                        </strong>

                    </div>

                    <div class="col-10 mb-1 small">توضیحات</div>

                </a>

                <a class="list-group-item list-group-item-action py-3 lh-tight pointer" (click)="setType(3)" id="3">

                    <div class="d-flex w-100 align-items-center justify-content-between">

                        <strong class="mb-1">کارتابل درخواست های سفر</strong>

                    </div>

                    <div class="col-10 mb-1 small">توضیحات</div>

                </a>

                <a class="list-group-item list-group-item-action py-3 lh-tight pointer" (click)="setType(4)" id="4">

                    <div class="d-flex w-100 align-items-center justify-content-between">

                        <strong class="mb-1">مدیریت درخواست های سفر</strong>

                    </div>

                    <div class="col-10 mb-1 small">توضیحات</div>

                </a>

            </div>

        </div>

    </ng-container>

    <div [ngClass]="bTravel || bStaffTravel || bManageTravel ? 'col-md-12 px-2' : 'col-md-10 px-2' ">

        <!-- loading -->

        <ng-container *ngIf="isLoading">

            <div class="d-flex justify-content-center align-items-center h-100">

                <img src="../../../assets/Img/loading_safar.gif" alt="loading">

            </div>

        </ng-container>

        <ng-container *ngIf="!isLoading">

            <ng-container *ngIf="menuType == 0">

                <div [ngClass]="appMenuType != -1 ? '' : 'mt-3' ">
    
                    <ng-container *ngIf="appMenuType != -1">
    
                        <div class="headerPart d-flex justify-content-center align-items-center bg-white p-2 mb-1 fw-bold">
    
                            <span> ثبت سفر </span>
        
                        </div>
    
                    </ng-container>

                    <!-- لیست مسیر های پر تردد -->

                    <ng-container *ngIf="isBusyRoutes">

                        <div class="d-flex flex-column justify-content-center align-items-center">

                            <input (keyup)="filter_list($event.target)" class="form-control mb-2"  placeholder="آدرس را جستحو کنید ..." >

                                <div class="w-100" style="max-height: 50vh;overflow: auto;">
                                    
                                    <table class="table table-striped border border-2 w-100">

                                        <thead class="text-center bg-white">

                                          <tr class="text-center">

                                            <th scope="col">#</th>

                                            <th scope="col-3"> نام </th>

                                            <th scope="col-9">آدرس</th>

                                          </tr>

                                        </thead>

                                        <tbody>

                                          <tr class="text-center pointer" [ngClass]="obj_TripSAD.iTripSAD == item.iTripSAD ? 'bg-success' : 'bg-white' " 
                                          
                                            *ngFor="let item of lst_TripSAD;let i = index" 
                                            
                                            (click)="selectTripSAD(item)">

                                            <th scope="row">{{ i + 1 | faNum}}</th>

                                            <td class="col-3"> {{ item?.strName  }} </td>

                                            <td class="col-9"> {{ item?.strAddress  }} </td>

                                          </tr>

                                        </tbody>

                                    </table>

                                </div>

                        </div>

                        <button class="btn btn-success mt-2" (click)="selectTripSAD('','confirm')"
                        
                            style="border-top-left-radius: 0; border-top-right-radius: 0;"> 
                            
                            تایید آدرس &nbsp; 
                            
                            <i class="fa fa-check fa-lg"></i>
                    
                        </button>
                    
                        <button class="btn btn-secondary mt-2 mx-2" (click)="isBusyRoutes = false"
                        
                            style="border-top-left-radius: 0; border-top-right-radius: 0;"> بازگشت &nbsp; 
                            
                            <i class="fa fa-close fa-lg"></i>
                        
                        </button>

                    </ng-container>

                    <!-- فرم ثبت سفر -->

                    <ng-container *ngIf="!isBusyRoutes">

                        <div class="accordion " id="accordionExample" [formGroup]="tripDet">
    
                            <div class="d-flex justify-content-between my-1">
        
                                <div class="selector py-1">
        
                                    <div class="selector-item" >
        
                                        <input type="radio" (change)="change_TripType('sideway')" id="sideway" name="selector" class="selector-item_radio" [checked]="(!bExclusive && !bMissionary && !bHaveReturn) ? true : false ">
        
                                        <label for="sideway" class="selector-item_label">یک طرفه 
                                            
                                            <i class="fa fa-long-arrow-right fa-lg" aria-hidden="true"></i>
                                        
                                        </label>
        
                                    </div>
        
                                    <div class="selector-item">
        
                                        <input type="radio" (change)="change_TripType('bHaveReturn')" id="bHaveReturn" name="selector" class="selector-item_radio" [checked]="bHaveReturn">
        
                                        <label for="bHaveReturn" class="selector-item_label">رفت و برگشت 
                                            
                                            <i class="fa fa-exchange fa-lg" aria-hidden="true"></i>
                                        
                                        </label>
        
                                    </div>
        
                                    <div class="selector-item">
        
                                        <input type="radio" (change)="change_TripType('bExclusive')" id="bExclusive" name="selector" class="selector-item_radio" [checked]="bExclusive">
        
                                        <label for="bExclusive" class="selector-item_label">در اختیار 
                                            
                                            <i class="fa fa-hand-paper-o fa-lg" aria-hidden="true"></i>
                                        
                                        </label>
        
                                    </div>
        
                                    <div class="selector-item">
        
                                        <input type="radio" (change)="change_TripType('bMissionary')" id="bMissionary" name="selector" class="selector-item_radio" [checked]="bMissionary">
        
                                        <label for="bMissionary" class="selector-item_label">مأموریتی 
                                            
                                            <i class="fa fa-user-secret fa-lg" aria-hidden="true"></i>
                                        
                                        </label>
        
                                    </div>
        
                                </div>
        
                            </div>
        
                            <div class="accordion-item">
                                
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne">
        
                                    <div class="accordion-body d-flex col-12 flex-wrap pb-4">
    
                                        <!-- جستجوی متقاضی -->
    
                                        <ng-container *ngIf="tripDet.controls['tripiPassenger'].value == ''">
    
                                            <div class="col-8 g-3 row">
    
                                                <input type="text" (keyup.enter)="searchPassenger(tripiPassenger.value)"
                                                        
                                                  placeholder="نام خانوادگی ، موبایل یا حوزه خدمت را جستجو کنید ..."
                                            
                                                  class="form-control" 
                                                    
                                                  #tripiPassenger>
    
                                            </div>
    
                                            <div class="col-2">
    
                                                <div class="w-100 px-3">
    
                                                    <button class="btn btn-primary w-100" [disabled]="isPassengerLoading"
                                                    
                                                        (click)="searchPassenger(tripiPassenger.value)"> 
                                                        
                                                        <span *ngIf="!isPassengerLoading">
    
                                                            جستحو
    
                                                        </span>
    
                                                        <span style="font-size: 14px;" *ngIf="isPassengerLoading">
    
                                                            لطفا منتظر بمانید ...
    
                                                        </span>
    
                                                    </button>
    
                                                </div>                                            
    
                                            </div>
    
                                            <!-- اگر اسم مورد نظر جز لیست نبود -->
                
                                            <ng-container>
                
                                                <div class="col-2">
    
                                                    <div class="w-100">
        
                                                        <button class="btn btn-success w-100" 
                                                        
                                                            (click)="newSafir(tripiPassenger.value)">
                                                            
                                                            متقاضی جدید  
                                                        
                                                        </button>
    
                                                    </div>                                            
        
                                                </div>
                
                                            </ng-container>
    
                                            <div class="col-8">
    
                                                <section class="search-results" style="right: -8px;">
            
                                                    <ul id="accordion-passengers" 
                                                    
                                                        [ngStyle]="{'padding': (filteredPassenger?.length > 0)? '5px': '0'}">
        
                                                        <ng-template class="accordion-results" ngFor let-person [ngForOf]="filteredPassenger" let-i="index">
        
                                                            <hr *ngIf="i > 0">
        
                                                            <li>
        
                                                                <label for="{{person.iPassenger}}">{{person.strFullName}} 
                                                                    
                                                                    <ng-container> ({{person.strMobileDomain_strComment | faNum}}) </ng-container>
        
                                                                    <span>
                                                                        
                                                                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                                                                    
                                                                    </span>
                                                                
                                                                </label>
        
                                                                <input type="radio" name="accordion" id="{{person.iPassenger}}">
        
                                                                <div class="content">
        
                                                                    <div class="d-flex justify-content-between" style="padding: 0 0.5rem;">
        
                                                                        <div class="row">
        
                                                                            <span> جایگاه سازمانی: 
                                                                                
                                                                                <strong>{{person.strUserManager_Chart_strComment | faNum}}</strong> 
                                                                            
                                                                            </span>
        
                                                                            <span>شماره تماس: 
                                                                                
                                                                                <strong>{{person.strMobile | faNum}}</strong>
                                                                            
                                                                            </span>
        
                                                                        </div>
        
                                                                        <button (click)="selectedSafir(person); tripiPassenger.value = person.strFullName" class="confirmPerson"> تایید </button>
        
                                                                    </div>
        
                                                                </div>
        
                                                            </li>
        
                                                        </ng-template>
        
                                                    </ul>
        
                                                </section>
    
                                            </div>
    
                                        </ng-container>
    
                                        <!-- اطلاعات متقاضی -->
    
                                        <ng-container *ngIf="tripDet.controls['tripiPassenger'].value != ''">
    
                                            <div class="col-4 g-3 row">
            
                                                <div class="col-auto" *ngIf="tripDet.controls['tripiPassenger'].value != ''">
            
                                                    <label for="tripPassenger" class="col-form-label">
    
                                                        {{ tripDet.controls['tripiPassenger'].value == '0' ? 'نام*' : 'متقاضی' }}
                                                        
                                                    
                                                    </label>
            
                                                </div>
            
                                                <div class="col-8 position-relative">
            
                                                    <div class="d-flex w-100">
            
                                                        <input type="text"  id="tripPassenger" class="form-control"  formControlName="safir" #tripiPassenger>
                    
                                                    </div>
            
                                                    <small *ngIf="tripDet.controls['tripiPassenger'].value != ''" 
                                                    
                                                        style="position: absolute;top: 8px;left: 11px;z-index: 99;">
                                                        
                                                        <i class="fa fa-close fa-lg text-danger pointer"  (click)="resetSafir()"></i>&nbsp;  
                                                    
                                                    </small>
            
                                                    <section class="search-results">
            
                                                        <p *ngIf="filteredPassenger?.length < 1 && hasQuery">
                                                            
                                                            <i> کاربری با این مشخصات پیدا نشد... </i>
                                                        
                                                        </p>
            
                                                        <ul id="accordion-passengers" [ngStyle]="{'padding': (filteredPassenger?.length > 0)? '5px': '0'}">
            
                                                            <ng-template class="accordion-results" ngFor let-person [ngForOf]="filteredPassenger" let-i="index">
            
                                                                <hr *ngIf="i > 0">
            
                                                                <li>
            
                                                                    <label for="{{person.iPassenger}}">{{person.strFullName}} 
                                                                        
                                                                        <ng-container> ({{person.strMobileDomain_strComment | faNum}}) </ng-container>
            
                                                                        <span>
                                                                            
                                                                            <i class="fa fa-caret-down" aria-hidden="true"></i>
                                                                        
                                                                        </span>
                                                                    
                                                                    </label>
            
                                                                    <input type="radio" name="accordion" id="{{person.iPassenger}}">
            
                                                                    <div class="content">
            
                                                                        <div class="d-flex justify-content-between" style="padding: 0 0.5rem;">
            
                                                                            <div class="row">
            
                                                                                <span> جایگاه سازمانی: 
                                                                                    
                                                                                    <strong>{{person.strUserManager_Chart_strComment | faNum}}</strong> 
                                                                                
                                                                                </span>
            
                                                                                <span>شماره تماس: 
                                                                                    
                                                                                    <strong>{{person.strMobile | faNum}}</strong>
                                                                                
                                                                                </span>
            
                                                                            </div>
            
                                                                            <button (click)="selectedSafir(person); tripiPassenger.value = person.strFullName" class="confirmPerson"> تایید </button>
            
                                                                        </div>
            
                                                                    </div>
            
                                                                </li>
            
                                                            </ng-template>
            
                                                        </ul>
            
                                                    </section>
            
                                                </div>
            
                                            </div>
            
                                            <div class="col-4 g-3 row" *ngIf="tripDet.controls['tripiPassenger'].value == '0' ">
            
                                                <div class="col-auto">
            
                                                    <label for="tripStrMobile" class="col-form-label"> نام خانوادگی*  </label>
            
                                                </div>
            
                                                <div class="col-auto">
            
                                                    <input type="text" id="safirFamily" placeholder="نام خانوادگی متقاضی" class="form-control" formControlName="safirFamily">
            
                                                </div>
            
                                            </div>
            
                                            <div class="col-4 g-3 row" *ngIf="tripDet.controls['tripiPassenger'].value != '' ">
            
                                                <div class="col-auto">
            
                                                    <label for="tripStrMobile" class="col-form-label"> موبایل*  </label>
            
                                                </div>
            
                                                <div class="col-8">
            
                                                    <input type="text" id="tripStrMobile" tripiPassenger [dir]="tripDet.controls['strMobile'].value == '' ? 'rtl' : 'ltr' " placeholder="موبایل متقاضی"
            
                                                        oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11"
                                                    
                                                        class="form-control" formControlName="strMobile">
            
                                                </div>
            
                                            </div>
            
                                            <div class="col-5 g-3 row mt-2" *ngIf="tripDet.controls['tripiPassenger'].value != ''">
            
                                                <div class="col-auto">
            
                                                    <label for="otherPassengers" class="col-form-label"> همراهان </label>
            
                                                </div>
            
                                                <div class="col-auto d-flex align-items-start">
            
                                                    <input type="text" id="otherPassengers" class="form-control" formControlName="otherp"
            
                                                        (keyup.enter)="addToOtherPassengers(0, otherPassenger.value); otherPassenger.value = ''; otherPassengers.focus()"  #otherPassenger>
            
                                                    <i class="fa fa-plus-circle fa-lg text-primary m-2 pointer" (click)="addToOtherPassengers(0, otherPassenger.value); otherPassenger.value = ''"></i>
            
                                                </div>
            
                                                <ng-container *ngIf="otherPassengers?.length > 0">
            
                                                    <section class="d-flex flex-wrap my-2">
            
                                                        <div class="my-1" *ngFor="let item of otherPassengers">
                                                            
                                                            <span class="otherPassengers">{{item.strName}} &nbsp; 
                                                                
                                                                <i class="fa fa-close pointer"  (click)="addToOtherPassengers(1, item)"></i>
                                                            
                                                            </span>
            
                                                        </div>
            
                                                    </section>
            
                                                </ng-container>
            
                                            </div>
            
                                            <div class="col-4 g-3 row  mt-2" *ngIf="tripDet.controls['tripiPassenger'].value != '' ">
            
                                                <div class="col-auto">
            
                                                    <label for="strPassengersMobile" class="col-form-label"> موبایل همراهان &nbsp; </label>
            
                                                </div>
            
                                                <div class="col-auto">
            
                                                    <input type="text" id="strPassengersMobile" strPassengersMobile dir="ltr" 
            
                                                        oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11"
                                                    
                                                        class="form-control" formControlName="strPassengersMobile">
            
                                                </div>
            
                                            </div>

                                            <div class="col-4 g-3 row  mt-2">
            
                                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                                    <input class="form-check-input m-0" type="checkbox" id="bCheckByQRCode" formControlName="bCheckByQRCode">
                                                
                                                    <label class="form-check-label pointer text-muted me-2" for="bCheckByQRCode"> نیاز به اعتبار سنجی مسافر </label>
                                                
                                                </div>
            
                                            </div>
    
                                        </ng-container>
    
        
                                    </div>
        
                                </div>
        
                            </div>
        
                            <div class="accordion-item">
                                <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo">
                                    <div class="accordion-body d-flex flex-wrap col-12">

                                        <div class="col-4 g-3 row align-items-center">
                                            <div class="col-auto">
                                                <label for="name" class="col-form-label">دلیل سفر</label>
                                            </div>
                                            <div class="col-8">
                                                <select (change)="setDropDown(0, $event.target.value)" formControlName="tripRes"
                                                    class="form-select">
                                                    <option value="-1" selected>انتخاب کنید...</option>
                                                    <option *ngFor="let item of tripReasons" value="{{item.tiTripReason}}">
                                                        {{item.strComment}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-4 g-3 row align-items-center">
                                            <div class="col-auto">
                                                <label for="name" class="col-form-label">اهمیت سفر</label>
                                            </div>
                                            <div class="col-8">
                                                <select (change)="setDropDown(1, $event.target.value)" formControlName="tripImp"
                                                    class="form-select">
                                                    <option value="-1" selected>انتخاب کنید...</option>
                                                    <option *ngFor="let item of tripImportance"
                                                        value="{{item.tiTripImportance}}">{{item.strComment}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-4 g-3 row align-items-center mb-2">
                                            <div class="col-auto">
                                                <label for="name" class="col-form-label">کاربری متحرک</label>
                                            </div>
                                            <div class="col-8">
                                                <select (change)="setDropDown(2, $event.target.value)"
                                                    formControlName="vehicleUs" class="form-select">
                                                    <option value="-1" selected>انتخاب کنید...</option>
                                                    <option *ngFor="let item of vehicleTypes" value="{{item.tiMobileType}}">
                                                        {{item.strComment}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        
                                        <div class="col-12 my-2"></div>

                                        <div class="col-4 g-3 row align-items-center">
                                            <div class="col-auto">
                                                <label for="name" class="col-form-label">تاریخ سفر</label>
                                            </div>
                                            <div class="col-8">
                                                <form [formGroup]="dates" style="margin-right: -2px; margin-left: 3px;">
                                                    <ng-persian-datepicker [timeEnable]="false"
                                                        [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                                        <input type="text" formControlName="OtripDate"
                                                            class="form-control text-end bg-white pointer" readonly />
                                                    </ng-persian-datepicker>
                                                </form>
                                            </div>
                                        </div>

                                        <div class="col-4 g-3 row align-items-center">

                                            <div class="col-auto">

                                                <label for="name" class="col-form-label">ساعت سفر</label>

                                            </div>

                                            <div class="col-8" style="margin-right: -2px;">
                                                
                                                <div class="input-group clockpicker mx-1">

                                                    <input type="text" class="form-control bg-white pointer rounded text-center" value="{{clockTime}}" id="Etime">

                                                    <span class="input-group-addon ">

                                                        <span class="glyphicon glyphicon-time"></span>

                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div *ngIf="bMissionary" class="col-4 g-3 row align-items-center">

                                            <div class="col-auto">

                                                <label for="name" class="col-form-label"> پایان مأموریت</label>

                                            </div>

                                            <div class="col-auto">

                                                <form [formGroup]="tripDet" style="margin-right: -2px; margin-left: 3px;">

                                                    <ng-persian-datepicker [timeEnable]="false"

                                                        [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                                                        <input type="text" formControlName="strEndMissionDate"

                                                            class="form-control text-end bg-white pointer" readonly />

                                                    </ng-persian-datepicker>

                                                </form>

                                            </div>

                                        </div>

                                        <div class="col-12 g-3 row mt-2">
        
                                            <div class="col-auto">
        
                                                <label for="name" class="col-form-label">توضیحات</label>
        
                                            </div>
        
                                            <div class="col-11">
        
                                                <textarea class="form-control" 
                                                
                                                formControlName="tripDescription" id="" cols="2" rows="2">
                                            
                                            </textarea>
        
                                            </div>
        
                                        </div>
        
                                    </div>
        
                                </div>
        
                            </div>
        
                            <div class="accordion-item">
        
                                <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree">
        
                                    <div class="accordion-body" [formGroup]="path">
        
                                        <div class="col-12 g-3 row align-items-center mb-4">
        
                                            <div class="col-1">
        
                                                <label for="name" class="col-form-label"> مبدأ</label>
        
                                            </div>
        
                                            <div class="col-11 d-flex">
        
                                                <div class="col-11">
        
                                                    <input type="text" class="form-control" formControlName="origin"

                                                        placeholder="بعد از وارد کردن آدرس  کلید 'Enter' را فشار دهید"
        
                                                        (keyup.enter)="getLocationGeocoding(0, 0, $event.target.value,'bLonChange');"

                                                        (keyup)="bLonChange=true"
        
                                                        #strAddress>
        
                                                    <small *ngIf="this.path.controls['olatIn']?.value == 0 && this.path.controls['olatIn']?.value != ''"  class="text-danger me-1">آدرس وارد شده صحیح نمی باشد</small>
        
                                                    <small *ngIf="this.path.controls['olatIn']?.value > 0 && this.path.controls['olatIn']?.value != ''"  class="text-success fw-bold me-1"> {{ origin?.strAddress }} </small>
        
                                                </div>
        
                                                <div class="col-1 d-flex justify-content-around align-items-start">
    
                                                    <!-- نمایش روی نقشه -->
    
                                                    <i style="background-color: #d4d4d4;" 
                                                    
                                                        class="fa fa-map-marker text-primary fa-lg pointer p-2 rounded" 
                                                    
                                                        (click)="newOpenMap(0,'bLonChange')" title="نمایش روی نقشه">
                                                    
                                                    </i>
    
                                                    <!-- مسیرهای پرتردد  -->
    
                                                    <i style="background-color: #d4d4d4;" 
                                                    
                                                        class="fa fa-list-alt text-secondary fa-lg pointer p-2 rounded" 
                                                        
                                                        (click)="openBusyRoutes(1)" title="مسیرهای پرتردد ">
                                                    
                                                    </i>
    
                                                </div>
        
                                            </div>
        
                                        </div>
        
                                        <div class="col-12 g-3 row align-items-center mb-2">
        
                                            <div class="col-1">
        
                                                <label for="name" class="col-form-label"> مقصد</label>
        
                                            </div>
        
                                            <div class="col-11 d-flex">
        
                                                <div class="col-11">
        
                                                    <input type="text" class="form-control" formControlName="destination"

                                                        placeholder="بعد از وارد کردن آدرس  کلید 'Enter' را فشار دهید"
        
                                                        (keyup.enter)="getLocationGeocoding(0, 1, $event.target.value,'bLatChange');"
                                                        
                                                        (keyup)="bLatChange=true" >
                                                        
        
                                                    <small *ngIf="this.path.controls['dlatIn']?.value == 0 && this.path.controls['dlatIn']?.value != ''" class="text-danger me-1">آدرس وارد شده صحیح نمی باشد</small>
        
                                                    <small *ngIf="this.path.controls['dlatIn']?.value > 0 && this.path.controls['dlatIn']?.value != ''" class="text-success fw-bold me-1">{{destination?.strAddress}}</small>
        
                                                </div>
    
                                                <div class="col-1 d-flex justify-content-around align-items-start">
    
                                                    <!-- نمایش روی نقشه -->
    
                                                    <i style="background-color: #d4d4d4;" 
                                                    
                                                        class="fa fa-map-marker text-primary fa-lg pointer p-2 rounded" 
                                                    
                                                        (click)="newOpenMap(1,'bLatChange')" title="نمایش روی نقشه">
                                                    
                                                    </i>
    
                                                    <!-- مسیرهای پرتردد  -->
    
                                                    <i style="background-color: #d4d4d4;" 
                                                    
                                                        class="fa fa-list-alt text-secondary fa-lg pointer p-2 rounded" 
                                                        
                                                        (click)="openBusyRoutes(2)" title="مسیرهای پرتردد ">
                                                    
                                                    </i>
    
                                                </div>
            
                                            </div>
        
                                        </div>
        
                                    </div>
        
                                </div>
        
                            </div>
        
                        </div>
        
                        <button (click)="sabtTrip()" class="btn btn-success mt-2" 
                        
                            style="border-top-left-radius: 0; border-top-right-radius: 0;">ثبت سفر &nbsp; 
                            
                            <i class="fa fa-check fa-lg"></i>
                        
                        </button>
                        
                        <button (click)="closeTrip()" class="btn btn-secondary mt-2 mx-2" 
                        
                            style="border-top-left-radius: 0; border-top-right-radius: 0;"> بستن &nbsp; 
                            
                            <i class="fa fa-close fa-lg"></i>
                        
                        </button>

                    </ng-container>
        
                </div>
    
            </ng-container>
    
            <ng-container *ngIf="menuType == 3">
    
                <app-trip-cartable></app-trip-cartable>
    
            </ng-container>
    
            <ng-container *ngIf="menuType == 4">
    
                <app-trip-management></app-trip-management>
    
            </ng-container>

        </ng-container>


    </div>

</main>

<!-- Map modal -->

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content p-1">
            <div class="modal-header dirI" style="height: 20px;">
                <h5 class="modal-title">{{mapHeader}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div id="map" class="position-sticky w-100 " style="height: 650px;">
                <div [formGroup]="path"
                    class="d-flex justify-content-around flex-wrap position-absolute dirI bg-th-yellow w-100 p-1 border-bottom border-info"
                    style="z-index: 1000; margin-bottom: 10px;">
                    <div class="d-none mx-1">
                        <label for="lat">عرض جغرافیایی:</label>
                        <input *ngIf="mapMode==0" readonly id="lat" type="text" formControlName="olatIn"
                            class="rounded mx-2">
                        <input *ngIf="mapMode==1" readonly id="lat" type="text" formControlName="dlatIn"
                            class="rounded mx-2">
                    </div>
                    <div class="d-none mx-1">
                        <label for="lon">طول جغرافیایی:</label>
                        <input *ngIf="mapMode==0" readonly id="lon" type="text" formControlName="olongIn"
                            class="rounded mx-2">
                        <input *ngIf="mapMode==1" readonly id="lat" type="text" formControlName="dlongIn"
                            class="rounded mx-2">
                    </div>

                    <div class="d-flex align-items-center px-2 py-2 col-11">

                        <label for="addressBar"> آدرس </label>

                        <input name="addressBar" formControlName="addressBar"

                            placeholder="آدرس خود را جستجو کنید ..."

                            (keyup.enter)="getLocationGeocoding(1, mapMode, $event.target.value)" type="text"

                            class="rounded w-100 ms-2 p-1" style="border: none;">
                    </div>

                </div>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- <button class="btn btn-secondary mx-2" data-bs-dismiss="modal"
                
                    style="border-top-left-radius: 0; border-top-right-radius: 0;"> بستن &nbsp; 
                
                    <i class="fa fa-close fa-lg"></i>
            
                </button> -->

                <button (click)="confirmMap()" data-bs-dismiss="modal" class="btn btn-success">
                    
                    تایید
                    
                    <i class="fa fa-check"></i>
                
                </button>

            </div>

        </div>

    </div>

</div>

<!-- Confirmation Modal -->

<div class="modal fade" id="confirmationMdl" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered dirI">
        <div class="modal-content">
            <div class="modal-body text-center">
                <span>درخواست شما با کد پیگیری <strong>{{tripID | faNum}}</strong> با موفقیت ثبت شد</span>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="resetForm()">تایید <i
                        class="fa fa-check"></i></button>
            </div>
        </div>
    </div>
</div>

